module.exports = __webpack_public_path__ + "static/knotheadbandwh-3582c26228a9c44096fac0989ff9db18.jpeg";